module.exports = __webpack_public_path__ + "img/fullStar.e4aee5c0.svg";